const a = "読み込み中", o = {
  loading: a
};
export {
  o as default,
  a as loading
};
